export const DUPLICATOR_DEFAULT_INTERVAL = { number: 1, type: 'weeks' }

export const DUPLICATOR_LOOKAHEAD = { number: 6, type: 'months' }

const INTERVAL_UNITS = {
  d: 'day',
  days: 'day',
  w: 'week',
  weeks: 'week',
  m: 'month',
  months: 'month',
  y: 'year',
  years: 'year'
}

export const duplicatorIntervalTypeValue = value => (Array.isArray(value) ? value[0] : value)

export const duplicatorAttributes = (interval = DUPLICATOR_DEFAULT_INTERVAL) => ({
  interval_number: Number(interval.number),
  interval_type: duplicatorIntervalTypeValue(interval.type),
  through_interval_number: DUPLICATOR_LOOKAHEAD.number,
  through_interval_type: DUPLICATOR_LOOKAHEAD.type
})

export const duplicatorRecurrenceDescription = attributes => {
  if (!attributes) return 'None'

  const number = Number(attributes.interval_number)
  const type = duplicatorIntervalTypeValue(attributes.interval_type)
  const unit = INTERVAL_UNITS[type]

  if (!unit || !number) return 'None'

  return number === 1 ? `Recurs every ${unit}` : `Recurs every ${number} ${unit}s`
}
